import { createFileRoute } from "@tanstack/react-router";
import { Users, Workflow, BarChart3 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import netImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/el/platform/crm")({
  head: () => ({
    meta: [
      { title: "CRM — banana.cards" },
      { name: "description", content: "CRM hiện đại, xây quanh cách bạn thực sự gặp gỡ. Επαφές, pipeline, task và analytics thời gian thực." },
      { property: "og:title", content: "CRM — banana.cards" },
      { property: "og:description", content: "CRM hiện đại, xây quanh cách bạn thực sự gặp gỡ." },
      { property: "og:image", content: netImg },
      { property: "og:locale", content: "el_GR" },
    ],
    links: alternateLinkList("/platform/crm", "el"),
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="CRM"
      title="Ένα CRM που"
      italic="γεμίζει μόνο του."
      description="Καταγράψτε κάθε επαφή τη στιγμή της γνωριμίας, προωθήστε κάθε συμφωνία και δείτε τι αποδίδει — όλα σε ένα μέρος."
      heroImage={netImg}
      features={[
        { title: "Επαφές", desc: "Mọi lead được ghi lại, làm giàu và khử trùng lặp tự động — từ quét, form, import và tích hợp.", href: "/el/platform/contacts", icon: Users, bullets: ["Tự làm giàu", "Khử trùng lặp thông minh", "Tag, segment & list"] },
        { title: "Pipeline & Task", desc: "Pipeline tùy chỉnh, kéo thả deal, task tự gán và theo dõi SLA — chốt nhanh hơn.", href: "/el/platform/pipelines", icon: Workflow, bullets: ["Pipeline không giới hạn", "Task với SLA", "Phân chia round-robin"] },
        { title: "Analytics", desc: "Dashboard thời gian thực qua thẻ, liên hệ, deal, hợp đồng và lịch hẹn — biết điều gì hiệu quả.", href: "/el/platform/analytics", icon: BarChart3, bullets: ["Dữ liệu thời gian thực", "Cohort & funnel", "Προσαρμοσμένες αναφορές"] },
      ]}
      outro={{ title: "Ghi một lần.", italic: "Chốt nhiều hơn.", description: "CRM gặp bạn ngay nơi cuộc trò chuyện thực sự diễn ra." }}
    />
  );
}